import { useMemo, useState } from "react";
import { FieldValues, UseFormReturn } from "react-hook-form";
import styled from "styled-components";
import { z } from "zod";
import { Button } from "../../atoms/Button";
import { Input } from "../../atoms/Input";
import FormTemplate from "../../templates/FormTemplate";

type Props = {
  handleSubmit: (password: string) => void;
  handleForgotPassword: () => void;
  handleBack: () => void;
};

export const LoginPasswordForm: React.FC<Props> = ({
  handleSubmit,
  handleForgotPassword,
  handleBack,
}) => {
  const schema = useMemo(() => {
    return z.object({
      password: z.string().min(1),
    });
  }, []);

  const [methods, setMethods] = useState<UseFormReturn<
    FieldValues,
    unknown,
    FieldValues
  > | null>(null);

  return (
    <FormTemplate
      schema={schema}
      setMethods={setMethods}
      defaultValues={{ password: "" }}
      onSubmit={({ password }) => handleSubmit(password)}
    >
      <StyledTextContainer>パスワードを入力してください。</StyledTextContainer>

      <Input label="パスワード" name="password" type="password" autoFocus />

      <StyledFooter>
        <Button variant="filled" text="次へ" type="submit" fullWidth />
        <Button text="戻る" variant="border" onClick={handleBack} />
        <Button
          variant="link"
          text="パスワードを忘れた方はこちら"
          type="button"
          onClick={handleForgotPassword}
        />
      </StyledFooter>
    </FormTemplate>
  );
};

const StyledTextContainer = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  margin-bottom: 24px;
`;

const StyledFooter = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 32px;
  gap: 20px;
`;
